import { DynamoNode, ElementNode, InputNode, NodeTag } from ".";
import { ElementType } from "../enums";
import { TemplateNodeVisitor } from "./ops/nodeVisitor";

export class RadioButtonGroupNode extends ElementNode {
    public constructor() {
        super();
        this.elementType = ElementType.RadioButtonGroup;
    }

    public accept(visitor: TemplateNodeVisitor) {
        visitor.visitRadioButtonGroupNode(this);
    }

    public tryAddChild(child: DynamoNode, index?: number) {
        if (child.tag !== "Element") {
            return false;
        }

        const elemNode = child as ElementNode;

        if (elemNode === undefined || elemNode.elementType !== ElementType.RadioButtonElement) {
            return false;
        }

        return super.tryAddChild(elemNode);
    }
}

export class RadioButtonElementNode extends InputNode<boolean> {
    public constructor() {
        super();
        this.elementType = ElementType.RadioButtonElement;
    }

    public accept(visitor: TemplateNodeVisitor) {
        visitor.visitRadioButtonElementNode(this);
    }
}

export class DropdownGroupNode extends InputNode<string> {
    public constructor() {
        super();
        this.elementType = ElementType.DropdownGroup;
    }

    public accept(visitor: TemplateNodeVisitor) {
        visitor.visitDropdownGroupNode(this);
    }

    public tryAddChild(child: DynamoNode, index?: number | undefined) {
        if (child.tag !== NodeTag.Element) {
            return false;
        }

        const elemNode = child as ElementNode;

        if (elemNode === undefined || elemNode.elementType !== ElementType.DropdownElement) {
            return false;
        }

        return super.tryAddChild(elemNode);
    }
}

export class DropdownElementNode extends ElementNode {
    public constructor() {
        super();
        this.elementType = ElementType.DropdownElement;
    }

    public accept(visitor: TemplateNodeVisitor) {
        visitor.visitDropdownElementNode(this);
    }
}
